// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Force MFA Modal Responsive & Professional Design ─────────────────────── */

/* Modal Base Wrapper */
.force-mfa-modal .ant-modal {
  margin: 16px auto !important;
  padding-bottom: 0 !important;
}

.force-mfa-modal .ant-modal-content {
  border-radius: 16px !important;
  box-shadow: 0 20px 45px -10px rgba(15, 23, 42, 0.18), 0 10px 20px -5px rgba(15, 23, 42, 0.1) !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  background: #ffffff !important;
}

/* Header badge */
.force-mfa-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  color: #2563eb;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
}

/* Modal Title */
.force-mfa-title {
  color: #0f172a !important;
  font-weight: 700 !important;
  line-height: 1.35 !important;
}

/* Modal Subtitle / Policy description */
.force-mfa-desc {
  color: #64748b !important;
  line-height: 1.45 !important;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

/* QR Code Card */
.force-mfa-qr-card {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);
  max-width: 100%;
}

.force-mfa-qr-img {
  display: block;
  border-radius: 6px;
}

/* Manual Key Container */
.force-mfa-secret-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  text-align: left;
}

.force-mfa-secret-label {
  display: block;
  color: #64748b;
  font-weight: 500;
  text-align: center;
}

.force-mfa-secret-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 5px 10px;
}

.force-mfa-secret-code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  letter-spacing: 0.06em !important;
  word-break: break-all !important;
  overflow-wrap: anywhere !important;
  flex: 1 1;
  -webkit-user-select: all;
          user-select: all;
}

.force-mfa-copy-btn {
  flex-shrink: 0;
  border-radius: 6px !important;
  font-weight: 500 !important;
}

/* OTP Form Section */
.force-mfa-otp-section {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
}

.force-mfa-otp-label {
  display: block;
  font-weight: 600;
  color: #334155;
  text-align: center;
}

.force-mfa-otp-input {
  text-align: center !important;
  letter-spacing: 0.35em !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;
  font-weight: 700 !important;
  border-radius: 8px !important;
  border-color: #cbd5e1 !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
  transition: all 0.2s ease !important;
}

.force-mfa-otp-input:focus {
  border-color: #2563eb !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) !important;
}

.force-mfa-otp-error {
  color: #ef4444;
  font-size: 0.78rem;
  margin-top: 4px;
  text-align: center;
}

/* Primary Verify Button */
.force-mfa-primary-btn {
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.22) !important;
  transition: all 0.2s ease !important;
}

.force-mfa-primary-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important;
  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.32) !important;
  transform: translateY(-1px);
}

.force-mfa-primary-btn:active:not(:disabled) {
  transform: translateY(0);
}

/* Backup Codes Section (Step 2) */
.force-mfa-backup-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 10px;
  margin-bottom: 14px;
}

.force-mfa-code-badge {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: 0.05em;
  text-align: center;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  -webkit-user-select: all;
          user-select: all;
  white-space: nowrap;
}

.force-mfa-actions-row {
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 14px;
}

.force-mfa-actions-row .ant-btn {
  flex: 1 1;
  height: 38px !important;
  border-radius: 6px !important;
  font-size: 0.82rem !important;
  font-weight: 500 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.force-mfa-finish-btn {
  height: 42px !important;
  font-size: 0.92rem !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #10b981 !important;
  border-color: #10b981 !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.22) !important;
}

.force-mfa-finish-btn:hover {
  background: #059669 !important;
  border-color: #059669 !important;
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.32) !important;
}

/* Logout link */
.force-mfa-logout-link {
  color: #94a3b8 !important;
  font-size: 0.82rem !important;
  padding: 4px 10px !important;
  height: auto !important;
}

.force-mfa-logout-link:hover {
  color: #64748b !important;
  text-decoration: underline !important;
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/* 🖥️ DESKTOP RULES (min-width: 768px): STRICTLY NO VERTICAL SCROLLBAR        */
/* ═══════════════════════════════════════════════════════════════════════════ */
@media (min-width: 768px) {
  .force-mfa-modal .ant-modal {
    width: 460px !important;
    max-width: 460px !important;
    margin: 24px auto !important;
  }

  .force-mfa-modal .ant-modal-content {
    padding: 20px 24px !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .force-mfa-modal .ant-modal-body {
    max-height: none !important;
    overflow: visible !important;
    overflow-y: visible !important;
    overflow-x: visible !important;
    padding: 0 !important;
  }

  .force-mfa-badge {
    width: 42px;
    height: 42px;
    font-size: 20px;
    margin-bottom: 8px;
  }

  .force-mfa-title {
    font-size: 1.15rem !important;
    margin-bottom: 4px !important;
  }

  .force-mfa-desc {
    font-size: 0.82rem !important;
    margin-bottom: 12px !important;
  }

  .force-mfa-qr-card {
    padding: 8px;
    margin-bottom: 10px;
  }

  .force-mfa-qr-img {
    width: 135px;
    height: 135px;
  }

  .force-mfa-secret-box {
    padding: 6px 10px;
    margin-bottom: 12px;
  }

  .force-mfa-secret-label {
    font-size: 0.76rem;
    margin-bottom: 4px;
  }

  .force-mfa-secret-code {
    font-size: 0.8rem !important;
  }

  .force-mfa-copy-btn {
    height: 28px !important;
    font-size: 0.78rem !important;
  }

  .force-mfa-otp-section {
    margin-bottom: 10px;
  }

  .force-mfa-otp-label {
    font-size: 0.82rem;
    margin-bottom: 6px;
  }

  .force-mfa-otp-input {
    height: 40px !important;
    font-size: 1.2rem !important;
  }

  .force-mfa-primary-btn {
    height: 40px !important;
    font-size: 0.92rem !important;
    margin-top: 10px;
  }

  .force-mfa-code-badge {
    font-size: 0.82rem;
    padding: 6px;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════ */
/* 📱 MOBILE RULES (max-width: 767px): RESPONSIVE SCROLLBAR ONLY WHEN NEEDED  */
/* ═══════════════════════════════════════════════════════════════════════════ */
@media (max-width: 767px) {
  .force-mfa-modal .ant-modal {
    max-width: calc(100vw - 24px) !important;
    margin: 12px auto !important;
    padding-bottom: 12px !important;
  }

  .force-mfa-modal .ant-modal-content {
    border-radius: 16px !important;
    padding: 20px 16px !important;
    max-height: calc(100vh - 24px) !important;
    max-height: calc(100dvh - 24px) !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .force-mfa-modal .ant-modal-body {
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
    padding: 2px 4px 6px 4px !important;
    max-height: calc(100vh - 60px) !important;
    max-height: calc(100dvh - 60px) !important;
  }

  /* Sleek scrollbar for mobile */
  .force-mfa-modal .ant-modal-body::-webkit-scrollbar {
    width: 5px;
  }
  .force-mfa-modal .ant-modal-body::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 4px;
  }
  .force-mfa-modal .ant-modal-body::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }

  .force-mfa-badge {
    width: 46px;
    height: 46px;
    font-size: 22px;
    margin-bottom: 10px;
  }

  .force-mfa-title {
    font-size: 1.1rem !important;
    margin-bottom: 6px !important;
  }

  .force-mfa-desc {
    font-size: 0.8rem !important;
    margin-bottom: 14px !important;
  }

  .force-mfa-qr-card {
    padding: 10px;
    margin-bottom: 14px;
  }

  .force-mfa-qr-img {
    width: 140px;
    height: 140px;
  }

  .force-mfa-secret-box {
    padding: 8px 10px;
    margin-bottom: 14px;
  }

  .force-mfa-secret-row {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .force-mfa-secret-code {
    text-align: center;
    font-size: 0.78rem !important;
    letter-spacing: 0.04em !important;
  }

  .force-mfa-copy-btn {
    width: 100%;
    height: 30px !important;
  }

  .force-mfa-otp-input {
    height: 42px !important;
    font-size: 1.15rem !important;
    letter-spacing: 0.28em !important;
  }

  .force-mfa-code-badge {
    font-size: 0.76rem;
    padding: 6px 4px;
    letter-spacing: 0.02em;
  }

  .force-mfa-actions-row {
    flex-direction: column;
    gap: 8px;
  }

  .force-mfa-actions-row .ant-btn {
    width: 100%;
  }

  .force-mfa-finish-btn {
    font-size: 0.88rem !important;
    height: 42px !important;
    white-space: normal;
    line-height: 1.2;
    padding: 6px 12px !important;
  }
}

/* ── Very Small Screens (< 350px) ─────────────────────────────────────────── */
@media (max-width: 350px) {
  .force-mfa-modal .ant-modal {
    max-width: calc(100vw - 12px) !important;
    margin: 8px auto !important;
  }

  .force-mfa-modal .ant-modal-content {
    padding: 14px 10px !important;
  }

  .force-mfa-qr-img {
    width: 120px;
    height: 120px;
  }

  .force-mfa-code-badge {
    font-size: 0.72rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/mfa/ForceMfaModal.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,uGAAuG;EACvG,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wFAAwF;EACxF,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,gCAAgC;EAChC,kCAAkC;EAClC,SAAO;EACP,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,wFAAwF;EACxF,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,uDAAuD;EACvD,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wEAAwE;EACxE,uBAAuB;EACvB,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,wBAAgB;UAAhB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,gFAAgF;AAChF,gFAAgF;AAChF,gFAAgF;AAChF;EACE;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA,gFAAgF;AAChF,+EAA+E;AAC/E,gFAAgF;AAChF;EACE;IACE,wCAAwC;IACxC,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,yCAAyC;IACzC,0CAA0C;IAC1C,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,4CAA4C;IAC5C,mCAAmC;IACnC,yCAAyC;IACzC,0CAA0C;EAC5C;;EAEA,+BAA+B;EAC/B;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;EAC9B;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Force MFA Modal Responsive & Professional Design ─────────────────────── */\n\n/* Modal Base Wrapper */\n.force-mfa-modal .ant-modal {\n  margin: 16px auto !important;\n  padding-bottom: 0 !important;\n}\n\n.force-mfa-modal .ant-modal-content {\n  border-radius: 16px !important;\n  box-shadow: 0 20px 45px -10px rgba(15, 23, 42, 0.18), 0 10px 20px -5px rgba(15, 23, 42, 0.1) !important;\n  border: 1px solid rgba(226, 232, 240, 0.8) !important;\n  background: #ffffff !important;\n}\n\n/* Header badge */\n.force-mfa-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  border: 1px solid #bfdbfe;\n  color: #2563eb;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);\n}\n\n/* Modal Title */\n.force-mfa-title {\n  color: #0f172a !important;\n  font-weight: 700 !important;\n  line-height: 1.35 !important;\n}\n\n/* Modal Subtitle / Policy description */\n.force-mfa-desc {\n  color: #64748b !important;\n  line-height: 1.45 !important;\n  max-width: 420px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* QR Code Card */\n.force-mfa-qr-card {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.05);\n  max-width: 100%;\n}\n\n.force-mfa-qr-img {\n  display: block;\n  border-radius: 6px;\n}\n\n/* Manual Key Container */\n.force-mfa-secret-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  text-align: left;\n}\n\n.force-mfa-secret-label {\n  display: block;\n  color: #64748b;\n  font-weight: 500;\n  text-align: center;\n}\n\n.force-mfa-secret-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  padding: 5px 10px;\n}\n\n.force-mfa-secret-code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;\n  font-weight: 600 !important;\n  color: #1e293b !important;\n  letter-spacing: 0.06em !important;\n  word-break: break-all !important;\n  overflow-wrap: anywhere !important;\n  flex: 1;\n  user-select: all;\n}\n\n.force-mfa-copy-btn {\n  flex-shrink: 0;\n  border-radius: 6px !important;\n  font-weight: 500 !important;\n}\n\n/* OTP Form Section */\n.force-mfa-otp-section {\n  width: 100%;\n  max-width: 320px;\n  margin: 0 auto;\n}\n\n.force-mfa-otp-label {\n  display: block;\n  font-weight: 600;\n  color: #334155;\n  text-align: center;\n}\n\n.force-mfa-otp-input {\n  text-align: center !important;\n  letter-spacing: 0.35em !important;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;\n  font-weight: 700 !important;\n  border-radius: 8px !important;\n  border-color: #cbd5e1 !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;\n  transition: all 0.2s ease !important;\n}\n\n.force-mfa-otp-input:focus {\n  border-color: #2563eb !important;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15) !important;\n}\n\n.force-mfa-otp-error {\n  color: #ef4444;\n  font-size: 0.78rem;\n  margin-top: 4px;\n  text-align: center;\n}\n\n/* Primary Verify Button */\n.force-mfa-primary-btn {\n  font-weight: 600 !important;\n  border-radius: 8px !important;\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;\n  border: none !important;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.22) !important;\n  transition: all 0.2s ease !important;\n}\n\n.force-mfa-primary-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%) !important;\n  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.32) !important;\n  transform: translateY(-1px);\n}\n\n.force-mfa-primary-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n/* Backup Codes Section (Step 2) */\n.force-mfa-backup-box {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px 10px;\n  margin-bottom: 14px;\n}\n\n.force-mfa-code-badge {\n  background: #ffffff;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  padding: 6px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 600;\n  color: #0f172a;\n  letter-spacing: 0.05em;\n  text-align: center;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n  user-select: all;\n  white-space: nowrap;\n}\n\n.force-mfa-actions-row {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  margin-bottom: 14px;\n}\n\n.force-mfa-actions-row .ant-btn {\n  flex: 1;\n  height: 38px !important;\n  border-radius: 6px !important;\n  font-size: 0.82rem !important;\n  font-weight: 500 !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.force-mfa-finish-btn {\n  height: 42px !important;\n  font-size: 0.92rem !important;\n  font-weight: 600 !important;\n  border-radius: 8px !important;\n  background: #10b981 !important;\n  border-color: #10b981 !important;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.22) !important;\n}\n\n.force-mfa-finish-btn:hover {\n  background: #059669 !important;\n  border-color: #059669 !important;\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.32) !important;\n}\n\n/* Logout link */\n.force-mfa-logout-link {\n  color: #94a3b8 !important;\n  font-size: 0.82rem !important;\n  padding: 4px 10px !important;\n  height: auto !important;\n}\n\n.force-mfa-logout-link:hover {\n  color: #64748b !important;\n  text-decoration: underline !important;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════ */\n/* 🖥️ DESKTOP RULES (min-width: 768px): STRICTLY NO VERTICAL SCROLLBAR        */\n/* ═══════════════════════════════════════════════════════════════════════════ */\n@media (min-width: 768px) {\n  .force-mfa-modal .ant-modal {\n    width: 460px !important;\n    max-width: 460px !important;\n    margin: 24px auto !important;\n  }\n\n  .force-mfa-modal .ant-modal-content {\n    padding: 20px 24px !important;\n    max-height: none !important;\n    overflow: visible !important;\n  }\n\n  .force-mfa-modal .ant-modal-body {\n    max-height: none !important;\n    overflow: visible !important;\n    overflow-y: visible !important;\n    overflow-x: visible !important;\n    padding: 0 !important;\n  }\n\n  .force-mfa-badge {\n    width: 42px;\n    height: 42px;\n    font-size: 20px;\n    margin-bottom: 8px;\n  }\n\n  .force-mfa-title {\n    font-size: 1.15rem !important;\n    margin-bottom: 4px !important;\n  }\n\n  .force-mfa-desc {\n    font-size: 0.82rem !important;\n    margin-bottom: 12px !important;\n  }\n\n  .force-mfa-qr-card {\n    padding: 8px;\n    margin-bottom: 10px;\n  }\n\n  .force-mfa-qr-img {\n    width: 135px;\n    height: 135px;\n  }\n\n  .force-mfa-secret-box {\n    padding: 6px 10px;\n    margin-bottom: 12px;\n  }\n\n  .force-mfa-secret-label {\n    font-size: 0.76rem;\n    margin-bottom: 4px;\n  }\n\n  .force-mfa-secret-code {\n    font-size: 0.8rem !important;\n  }\n\n  .force-mfa-copy-btn {\n    height: 28px !important;\n    font-size: 0.78rem !important;\n  }\n\n  .force-mfa-otp-section {\n    margin-bottom: 10px;\n  }\n\n  .force-mfa-otp-label {\n    font-size: 0.82rem;\n    margin-bottom: 6px;\n  }\n\n  .force-mfa-otp-input {\n    height: 40px !important;\n    font-size: 1.2rem !important;\n  }\n\n  .force-mfa-primary-btn {\n    height: 40px !important;\n    font-size: 0.92rem !important;\n    margin-top: 10px;\n  }\n\n  .force-mfa-code-badge {\n    font-size: 0.82rem;\n    padding: 6px;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════ */\n/* 📱 MOBILE RULES (max-width: 767px): RESPONSIVE SCROLLBAR ONLY WHEN NEEDED  */\n/* ═══════════════════════════════════════════════════════════════════════════ */\n@media (max-width: 767px) {\n  .force-mfa-modal .ant-modal {\n    max-width: calc(100vw - 24px) !important;\n    margin: 12px auto !important;\n    padding-bottom: 12px !important;\n  }\n\n  .force-mfa-modal .ant-modal-content {\n    border-radius: 16px !important;\n    padding: 20px 16px !important;\n    max-height: calc(100vh - 24px) !important;\n    max-height: calc(100dvh - 24px) !important;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n  }\n\n  .force-mfa-modal .ant-modal-body {\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n    -webkit-overflow-scrolling: touch !important;\n    padding: 2px 4px 6px 4px !important;\n    max-height: calc(100vh - 60px) !important;\n    max-height: calc(100dvh - 60px) !important;\n  }\n\n  /* Sleek scrollbar for mobile */\n  .force-mfa-modal .ant-modal-body::-webkit-scrollbar {\n    width: 5px;\n  }\n  .force-mfa-modal .ant-modal-body::-webkit-scrollbar-track {\n    background: #f1f5f9;\n    border-radius: 4px;\n  }\n  .force-mfa-modal .ant-modal-body::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 4px;\n  }\n\n  .force-mfa-badge {\n    width: 46px;\n    height: 46px;\n    font-size: 22px;\n    margin-bottom: 10px;\n  }\n\n  .force-mfa-title {\n    font-size: 1.1rem !important;\n    margin-bottom: 6px !important;\n  }\n\n  .force-mfa-desc {\n    font-size: 0.8rem !important;\n    margin-bottom: 14px !important;\n  }\n\n  .force-mfa-qr-card {\n    padding: 10px;\n    margin-bottom: 14px;\n  }\n\n  .force-mfa-qr-img {\n    width: 140px;\n    height: 140px;\n  }\n\n  .force-mfa-secret-box {\n    padding: 8px 10px;\n    margin-bottom: 14px;\n  }\n\n  .force-mfa-secret-row {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 6px;\n  }\n\n  .force-mfa-secret-code {\n    text-align: center;\n    font-size: 0.78rem !important;\n    letter-spacing: 0.04em !important;\n  }\n\n  .force-mfa-copy-btn {\n    width: 100%;\n    height: 30px !important;\n  }\n\n  .force-mfa-otp-input {\n    height: 42px !important;\n    font-size: 1.15rem !important;\n    letter-spacing: 0.28em !important;\n  }\n\n  .force-mfa-code-badge {\n    font-size: 0.76rem;\n    padding: 6px 4px;\n    letter-spacing: 0.02em;\n  }\n\n  .force-mfa-actions-row {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .force-mfa-actions-row .ant-btn {\n    width: 100%;\n  }\n\n  .force-mfa-finish-btn {\n    font-size: 0.88rem !important;\n    height: 42px !important;\n    white-space: normal;\n    line-height: 1.2;\n    padding: 6px 12px !important;\n  }\n}\n\n/* ── Very Small Screens (< 350px) ─────────────────────────────────────────── */\n@media (max-width: 350px) {\n  .force-mfa-modal .ant-modal {\n    max-width: calc(100vw - 12px) !important;\n    margin: 8px auto !important;\n  }\n\n  .force-mfa-modal .ant-modal-content {\n    padding: 14px 10px !important;\n  }\n\n  .force-mfa-qr-img {\n    width: 120px;\n    height: 120px;\n  }\n\n  .force-mfa-code-badge {\n    font-size: 0.72rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
